export default {"src":"/_next/static/media/Border.ad8c8fa0.svg","height":95,"width":183,"blurWidth":0,"blurHeight":0};